import React, { Component } from "react";


class Hint extends Component {

  shoot = () => {
    alert(this);
    
  }

 render() {
  return (
    <div class="py-2 w-100">
      {/* <img src={FirstNotification} className="notification1" alt="" />
      <a className="first-notification close" href="/">
        <img src={Close} alt="" />
      </a> */}
      <div class="dialog pl-4 pr-4">
        <h5 className="mb-0">Oh so close, keep going on the same line.</h5>
        <h3>This game is not time bound</h3>
        <p>
          Take as much as time you can to crack this level. You can unlock a hint at every 30 mins upto 3 hints and you cannot use them at any level
        </p>
        <button onClick={this.shoot} className="btn btn-yellow">OKAY</button>
        <button onClick={this.shoot} class="close-classic">&nbsp;</button>
      </div>
    </div>
  );
}
}
export default Hint;
